import { Breakpoints } from '@owc-utils/MediaQueryService';
/**
 * TODO: If a value is set, there are times where the throttle will not run when it should.
 * But disabling the throttle will have an impact on performance, so this should be checked.
 * Maybe the passive option given to the scroll handler helps but this needs more investigation
 * */
export const SUBNAVIGATION_SCROLL_THROTTLE_LIMIT = 0;
export const SUBNAVIGATION_DEBOUNCE_TIME = 300;
export const SUBNAVIGATION_STAGE_COVERAGE_BEFORE_LEAVE = 0.8; // 80%
export const STAGE_TAG_NAME_LIST = ['owc-stage', 'emh-stage-campaign-item'];

/** These variables are directly attached to CSS
 * If you change these, don't forget to change them
 * on the ./Subnavigation.vue on the <style> section
 * **/

export const SUBNAVIGATION_ARROW_BACKGROUND_WIDTH = 90;
export const SUBNAVIGATION_ITEM_GAP = 16;

/** **/

export const CONSIDERED_VISIBLE_THRESHOLD = 0.8;
export const MOBILE_BREAKPOINTS_SUBNAVIGATION = [
  Breakpoints.mq1,
  Breakpoints.mq2,
  Breakpoints.mq3,
  Breakpoints.mq4,
];
